import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ScriptTag from 'react-script-tag';
import {
  Button,
  Card,
  CARD_SIZE,
  Checkbox,
  Chips,
  CHIPS_COLOR,
  CreditCard,
  CreditCardAmex,
  CreditCardGeneric,
  CreditCardExpiration,
  Icon,
  InputText,
  Link,
  Select,
  ValidateName,
} from 'veloe-ds';
import alert from '../../assets/icons/alert.svg';
import atencao from '../../assets/icons/atencao.svg';
import credit from '../../assets/icons/general-credit-card.svg';
import debit from '../../assets/icons/general-debit.svg';
import braspag from '../../api/Braspag';
import vindi from '../../api/Vindi';
import api, { isCancel } from '../../api/api';
import './formaPagamento.scss';
import visa from '../../assets/icons/visa.svg';
import master from '../../assets/icons/master.svg';
import alelo from '../../assets/icons/alelo.png';
import aleloLogo from '../../assets/icons/alelo.png';
import elo from '../../assets/icons/elo.svg';
import amex from '../../assets/icons/amex.svg';

import { getData } from '../../api/dataAPI';
import { APP_PAGES } from '../../routes';
import {
  modalFinalizandoPagamento,
  modalInformativo,
} from '../../Components/Modais';
import {
  validateCreditCard,
  validateCreditCardFlag,
  BANKS,
  validateDVAccount,
  validateItauDVAccount,
} from './validators';

import { veloeGraphQlApi } from '../../api/graphql/graphQLAPI';
import dadosDePagamentoValido from '../../mutations/dadosPagValido';
import visaLogo from '../../assets/icons/visa.png';
import masterLogo from '../../assets/icons/master.png';
import eloLogo from '../../assets/icons/elo.png';
import amexLogo from '../../assets/icons/amex.png';
import { withSnackbar } from 'notistack';
import {
  ANALISE_FRAUDE_APROVADA,
  DADOS_PAGAMENTO_NAO_VALIDADO_MANTER_DADOS,
  FINALIZADA_COM_SUCESSO,
  FALHA_VALIDAR_BIN_COM_CODIGO_PROMOCIONAL,
} from '../../utils/statusProposal';
import {
  GENERIC_NOT_ALLOWED_MESSAGE,
  GENERIC_PAYMENT_MESSAGE,
  INSTABILITY_MESSAGE,
  GENERIC_NOT_ALLOWED_BIN_TITLE_MESSAGE,
  GENERIC_NOT_ALLOWED_BIN_MESSAGE,
} from '../../utils/messages';
import buscarArquivos from '../../queries/buscarArquivos';
import {
  eventTrackBasic,
  eventTrackEcommerce,
  eventTrackRoute,
} from '../../utils/pushDataLayer.js';
import TagManager from 'react-gtm-module';

const BANK_CODE = {
  BB: '001',
  BRADESCO: '237',
  ITAU: '341',
  ORIGINAL: '212',
};

/**
 * Realiza o cadastro do pagamento
 *
 * Durante o processo vai armazenar as seguintes variáveis:
 *
 *  dadosCartaoDebito: dicionário contendos as informações do cartão: numero, validade, CVV, melhorDiaCobranca,
 *  dadosCartao: dicionário contendos as informações do cartão: numero, validade, CVV, melhorDiaCobranca,
 *  debitoEmConta: dicionário contendo as informações da conta: instituicao, agencia, conta, melhorDiaCobranca,
 *  dadosDePagamentoValido: informacões do sucesso no pagamento: status-  (true ou false) , tipo - 1: cartão, 2: débito em conta,
 *  checkboxTermos: booleano que indica o aceite dos termos de uso
 *
 * */

const CardIcon = ({ src, alt }) => {
  return (
    <img
      src={src}
      alt={alt}
      style={{ width: '36px', top: '5px', position: 'relative' }}
    />
  );
};

class FormaPagamento extends Component {
  constructor(props) {
    super(props);
    let {
      dadosCartaoDebito,
      dadosCartao,
      debitoEmConta,
      dadosDePagamentoValido,
      tipoPagamento,
      dadosUsuario,
    } = this.props.pedido;
    if (tipoPagamento !== 'pos-pago') {
      dadosDePagamentoValido.tipo = 'credito';
    }

    this.state = {
      disableCardClick: false,
      showDebitTip: false,
      botaoContinuar: {
        status: true,
        label: 'Aceite os termos para continuar',
      },
      botaoOKcartao: { status: true, label: 'OK' },
      botaoOKdebito: { status: true, label: 'OK' },
      dadosUsuario,
      dadosCartaoDebito,
      dadosCartao,
      debitoEmConta,
      dadosDePagamentoValido,
      checkboxTermos: false,
      tipoPagamento,
      possuiDebito: tipoPagamento === 'pos-pago',
      semMensalidade: tipoPagamento === '',
      openModalAguarde: false,
      openModalInformativo: false,
      openModalAtencao: false,
      openModalTermos: false,
      binCodeError: false,
      errorMessage: '',
      errorTitleMessage: '',
      bandeira: '',
      disableAgencia: false,
      bankOptions: [],
      bestDayForBilling: [],
      urlContratoVeloeCliente: '',
      urlManualUsuario: '',
      urlPoliticaDePrivacidade: '',
      versionContratoVeloeCliente: '',
      validaAgenciaAlert: false,
      showMask: false,
      paymentLayerType: 'nao-selecionado',
      primeiroClick: false,
    };

    this.formPayment = null;
    this.instituicoes = getData('instituicoes');
    this.diaPagto = getData('diaPagto');
    this.textoTermos = getData('modalTermos').conteudo;
  }

  BLACKLIST_DEBIT_PAYMENT = [
    'ELOPOS',
    'CETE20POS',
    'VELOENEXTPOS',
    'NEXTPOS',
    'MBVELOEPOS',
    'BRBCARDCURTAIPOS',
    'BRBCARDSTOCKCARPOS',
    'VELOEBRBFLAMENGOPOS',
  ];

  onTheBlacklist = (promoCode) => {
    const result = this.BLACKLIST_DEBIT_PAYMENT.includes(promoCode);

    return result;
  };

  componentDidMount = () => {
    this.buscarArquivos();
    const { history } = this.props;
    const propostaFinalizada = JSON.parse(
      localStorage.getItem('propostaFinalizada'),
    );
    const proposta = JSON.parse(localStorage.getItem('proposta'));
    if (propostaFinalizada) {
      history.push(APP_PAGES.RETURN_PEDIDO_CONCLUIDO);
    } else {
      if (!proposta) {
        history.push(APP_PAGES.CADASTRO);
      }
    }

    eventTrackEcommerce(this.props.pedido, proposta, ['checkout', 2]);
    eventTrackRoute('forma-pagamento');

    api()
      .get(`/publico/bancos`)
      .then(({ data }) => {
        this.setState({ bankOptions: data });
      })
      .catch((err) => {
        console.log(isCancel(err) ? 'Abort request' : err);
      });
  };

  buscarArquivos = () => {
    veloeGraphQlApi(buscarArquivos)
      .then((data) => {
        const {
          urlContratoVeloeCliente,
          urlManualUsuario,
          urlPoliticaDePrivacidade,
          versionContratoVeloeCliente,
        } = data['buscarArquivos'];

        this.setState({
          urlContratoVeloeCliente: urlContratoVeloeCliente,
          urlManualUsuario: urlManualUsuario,
          urlPoliticaDePrivacidade: urlPoliticaDePrivacidade,
          versionContratoVeloeCliente: versionContratoVeloeCliente,
        });
      })
      .catch((err) => {
        this.setState({
          errorTitleMessage: 'Ops!',
          errorMessage: err.message,
          openModalInformativo: true,
        });
        eventTrackBasic('callback:pagamento', `erro:${err.message}`);
      });
  };

  limpaDados = (tipo) => {
    if (!this.state.disableCardClick) {
      if (tipo === 'credito' && this.state.possuiDebito) {
        let dadosCartao = {
          numero: '',
          validade: '',
          CVV: '',
          melhorDiaCobranca: '',
          nome: '',
        };
        if (this.props.pedido.tipoPagamento === 'pos-pago') {
          this.setState({
            dadosCartao,
            dadosDePagamentoValido: { status: false, tipo: 'credito' },
          });
        }
      } else if (tipo === 'cartaoDebito') {
        let dadosCartaoDebito = {
          numero: '',
          validade: '',
          CVV: '',
          melhorDiaCobranca: '',
        };
        if (this.props.pedido.tipoPagamento === 'pos-pago') {
          this.setState({
            dadosCartaoDebito,
            dadosDePagamentoValido: { status: false, tipo: 'cartaoDebito' },
          });
        }
      } else {
        let debitoEmConta = {
          agencia: '',
          instituicao: '',
          digitoConta: '',
          melhorDiaCobranca: '',
        };
        if (this.props.pedido.tipoPagamento === 'pos-pago') {
          this.setState({
            debitoEmConta,
            dadosDePagamentoValido: { status: false, tipo: 'debito' },
          });
        }
      }
    }
  };

  changeFormularioDadosCartao = (value, key) => {
    const { dadosCartaoDebito, dadosCartao, dadosDePagamentoValido } =
      this.state;

    if (key === 'numero') {
      value = value.replaceAll('_', '');
    }

    if (dadosDePagamentoValido.tipo === 'cartaoDebito') {
      dadosCartaoDebito[key] = value;
      this.setState({ ...dadosCartaoDebito });
    } else {
      dadosCartao[key] = value;
      this.setState({ ...dadosCartao });
    }

    if (
      (this.objetoEhValido('cartao') &&
        this.verifyNameCard(dadosCartao.nome)) ||
      (dadosCartaoDebito &&
        this.objetoEhValido('cartaoDebito') &&
        this.verifyNameCard(dadosCartaoDebito.nome))
    ) {
      this.setState({ botaoOKcartao: { status: false, label: 'OK' } });
    } else {
      this.setState({ botaoOKcartao: { status: true, label: 'OK' } });
    }
    if (key === 'numero') {
      this.verificarTrocaCartao(value);
    }
  };

  objetoEhValido = (tipo) => {
    const { dadosCartaoDebito, dadosCartao, debitoEmConta } = this.state;

    if (tipo === 'cartao') {
      return this.state.semMensalidade
        ? this.verificaCartao(dadosCartao.numero) &&
            this.verificaCVV(dadosCartao.CVV) &&
            this.verificaValidade(dadosCartao.validade)
        : this.verificaCartao(dadosCartao.numero) &&
            this.verificaCVV(dadosCartao.CVV) &&
            this.state.dadosCartao.melhorDiaCobranca > 0 &&
            this.verificaValidade(dadosCartao.validade);
    } else if (tipo === 'cartaoDebito') {
      return (
        this.verificaCartao(dadosCartaoDebito.numero) &&
        this.verificaCVV(dadosCartaoDebito.CVV) &&
        this.state.dadosCartaoDebito.melhorDiaCobranca > 0 &&
        this.verificaValidade(dadosCartaoDebito.validade)
      );
    } else {
      return (
        this.verifyAgency(debitoEmConta.agencia) &&
        debitoEmConta.instituicao.length > 0 &&
        this.verifyBankAccountNumber(debitoEmConta.conta) &&
        debitoEmConta.digitoConta.length > 0 &&
        debitoEmConta.melhorDiaCobranca > 0
      );
    }
  };

  changeDbtContaFormulario = (value, key) => {
    const { debitoEmConta } = this.state;
    debitoEmConta[key] = value;
    if (key === 'instituicao') {
      if (value === '212 - Banco Original S.A.') {
        debitoEmConta.agencia = '0001';
        this.setState({ disableAgencia: true });
      } else {
        this.setState({ disableAgencia: false });
      }
    }
    this.setState({ debitoEmConta });
    if (!this.objetoEhValido('debito')) {
      this.setState({
        botaoOKdebito: { status: true, label: 'Ok' },
        validaAgenciaAlert: false,
      });
    } else {
      if (this.validateAgencyDV(debitoEmConta).valid) {
        this.setState({
          botaoOKdebito: { status: false, label: 'Ok' },
          validaAgenciaAlert: false,
        });
      } else {
        this.setState({
          botaoOKdebito: { status: true, label: 'Ok' },
          validaAgenciaAlert: true,
        });
      }
    }
  };

  alteraCheckBox = () => {
    const { checkboxTermos } = this.state;

    this.setState({
      checkboxTermos: !checkboxTermos,
      botaoContinuar: {
        status: checkboxTermos,
        label: checkboxTermos
          ? 'Aceite os termos para continuar'
          : 'Finalizar compra',
      },
    });
    eventTrackBasic(
      'interacao:checkbox',
      `${
        this.state.checkboxTermos ? 'desselecionou' : 'selecionado'
      }:termos-condicoes`,
    );
  };

  geraPagamentoId = async () => {
    const paymentToken = await this.getPaymentToken();
    if (!paymentToken) {
      this.setState({
        idtransacao: '',
        openModalInformativo: true,
        errorMessage:
          'Infelizmente, não conseguimos validar seus dados! Confira se os dados digitados estão corretos e tente novamente mais tarde.',
      });
      eventTrackBasic('callback:pagamento', 'erro:dados-incorretos');
    } else {
      const paymentTokenVindi = await this.getPaymentTokenVindi();
      this.setState({ idtransacao: paymentToken, paymentTokenVindi });
      this.chamaFuncRand();
    }
  };

  creditCardMask = (cardNumber) => {
    if (cardNumber) {
      return (
        cardNumber
          .replace(/[^\dA-Z]/g, '')
          .replace(/(.{4})/g, '$1 ')
          .replace(/[^0-9. ]+/g, '')
          .trim()
          .substring(0, 7) +
        'XX-XXXX-' +
        cardNumber
          .replace(/[^\dA-Z]/g, '')
          .replace(/(.{4})/g, '$1 ')
          .replace(/[^0-9. ]+/g, '')
          .trim()
          .substring(15)
      ).replace(/\s/g, '-');
    } else {
      return '';
    }
  };

  messageError = (message, title) => {
    const { inactiveLoader } = this.props;
    inactiveLoader();
    this.setState({
      errorTitleMessage: title,
      errorMessage: message,
      openModalInformativo: true,
    });
    eventTrackBasic('callback:pagamento', `erro:${message}`);
  };

  chamaFuncRand = async () => {
    const { activeLoader, inactiveLoader, history, pedido } = this.props;
    const proposta = JSON.parse(localStorage.getItem('proposta'));
    const cardNumberMask = this.creditCardMask(
      this.state.dadosDePagamentoValido.tipo === 'cartaoDebito'
        ? this.state.dadosCartaoDebito.numero
        : this.state.dadosCartao.numero,
    );
    const reCaptcha = await window.grecaptcha.execute(
      process.env.REACT_APP_KEY_RECAPTCHA,
      {
        action: 'homepage',
      },
    );

    activeLoader();

    let isCartaoDebito =
      this.state.dadosDePagamentoValido.tipo === 'cartaoDebito';
    let isCredito = this.state.dadosDePagamentoValido.tipo === 'credito';
    let isCuenta = this.state.dadosDePagamentoValido.tipo === 'debito';

    veloeGraphQlApi(dadosDePagamentoValido, {
      idProposta: proposta.dados.id,
      fingerprintSessionId: 'dhwqe-nyqwepw-johre',
      versaoTermoAceite: this.state.versionContratoVeloeCliente,
      nome: isCredito
        ? this.state.dadosCartao?.nome?.toUpperCase()
        : isCartaoDebito
        ? this.state.dadosCartaoDebito?.nome?.toUpperCase()
        : undefined,
      bandeira: isCredito || isCartaoDebito ? this.state.bandeira : undefined,
      cvv: isCredito
        ? this.state.dadosCartao.CVV
        : isCartaoDebito
        ? this.state.dadosCartaoDebito.CVV
        : undefined,
      numeroMascarado: isCredito || isCartaoDebito ? cardNumberMask : undefined,
      validade: isCredito
        ? this.state.dadosCartao.validade
        : isCartaoDebito
        ? this.state.dadosCartaoDebito.validade
        : undefined,
      paymentToken: this.state.idtransacao,
      codigoBanco: isCuenta
        ? this.state.debitoEmConta.instituicao.substring(0, 3)
        : undefined,
      agencia: isCuenta ? this.state.debitoEmConta.agencia : undefined,
      conta: isCuenta ? this.state.debitoEmConta.conta : undefined,
      digitoConta: isCuenta ? this.state.debitoEmConta.digitoConta : undefined,
      melhorDiaCobranca: isCuenta
        ? this.state.debitoEmConta.melhorDiaCobranca
        : undefined,
      formaPagamento: isCredito
        ? 'CAJA'
        : isCartaoDebito
        ? 'CARTAO_DEBITO'
        : 'CUENTA',
      vencimentoFatura: Number(
        isCredito
          ? pedido.ondeUsar.subProdutoId !== '001'
            ? this.state.dadosCartao.melhorDiaCobranca
            : 10
          : isCartaoDebito
          ? this.state.dadosCartaoDebito.melhorDiaCobranca
          : this.state.debitoEmConta.melhorDiaCobranca,
      ),
      captchaResponse: reCaptcha,
      gateways: [{ id: 'VINDI', token: this.state.paymentTokenVindi }],
    })
      .then((data) => {
        const { dados, validatorResponse } = data['dadosPagValidoFCG'];

        if (dados === null && validatorResponse && validatorResponse.errors) {
          inactiveLoader();
          this.setState({
            errorMessage: validatorResponse.errors[0].message,
            openModalInformativo: true,
          });
        } else {
          switch (dados.situacaoProposta) {
            case FINALIZADA_COM_SUCESSO:
              inactiveLoader();
              history.push(APP_PAGES.PEDIDO_CONCLUIDO);
              break;

            case ANALISE_FRAUDE_APROVADA:
              this.messageError(GENERIC_PAYMENT_MESSAGE, 'Ops!');
              break;

            case FALHA_VALIDAR_BIN_COM_CODIGO_PROMOCIONAL:
              this.messageError(
                GENERIC_NOT_ALLOWED_BIN_MESSAGE,
                GENERIC_NOT_ALLOWED_BIN_TITLE_MESSAGE,
              );
              break;

            case DADOS_PAGAMENTO_NAO_VALIDADO_MANTER_DADOS:
              this.messageError(GENERIC_NOT_ALLOWED_MESSAGE, 'Ops!');
              break;

            case null:
              this.messageError(INSTABILITY_MESSAGE, 'Ops!');
              break;

            default:
              this.messageError(GENERIC_PAYMENT_MESSAGE, 'Ops!');
              break;
          }
        }
      })
      .catch((err) => {
        inactiveLoader();
        console.log(err);
        this.setState({
          errorMessage: err[0].message,
          openModalInformativo: true,
        });
        eventTrackBasic('callback:pagamento', `erro:${err[0].message}`);
      });
  };

  sendDataLayer = () => {
    const {
      listaDeProdutos,
      tipoVeiculo,
      valorTotalProdutos,
      idtransacao,
      tipoPagamento,
      cupomDesconto,
      ondeUsar,
    } = this.props.pedido;

    const datalist = listaDeProdutos.map((produto) => {
      return {
        price: produto.valor,
        quantity: produto.quantidade,
        name: produto.id,
        category: tipoVeiculo,
        variant: ondeUsar.id,
      };
    });

    TagManager.dataLayer({
      dataLayer: {
        event: 'purchase',
        eventCategory: 'veloe:contratacao',
        eventAction: 'view:enhanced-ecommerce',
        eventLabel: 'sucesso',
        ecommerce: {
          purchase: {
            actionField: {
              id: idtransacao,
              affiliation: tipoPagamento,
              revenue: valorTotalProdutos,
              coupon: cupomDesconto,
            },
            products: datalist,
          },
        },
      },
    });

    TagManager.dataLayer({
      dataLayer: {
        event: 'checkout',
        eventCategory: 'veloe:contratacao',
        eventAction: 'view:enhanced-ecommerce',
        eventLabel: 'pagamento',
        ecommerce: {
          checkout: {
            actionField: { step: '9' },
          },
        },
      },
    });
  };

  getBandeiraVindi(bandeira) {
    switch (bandeira) {
      case 'amex':
        return 'american_express';
      case 'master':
        return 'mastercard';
      default:
        return bandeira;
    }
  }

  getPaymentTokenVindi = async () => {
    let paymentTokenVindi = '';
    let { dadosCartao, dadosUsuario } = this.state;

    await api()
      .get('/publico/gateway/vindi/auth', {})
      .then(async (response) => {
        const request = {
          holder_name: this.formatCardHolderName(dadosCartao.nome),
          registry_code: dadosUsuario.cpf.replace(/[^0-9]/g, ''),
          card_expiration: dadosCartao.validade,
          card_number: dadosCartao.numero.replace(/[\s _]/g, ''),
          card_cvv: dadosCartao.CVV,
          payment_method_code: 'credit_card_bradesco',
          payment_company_code: this.getBandeiraVindi(dadosCartao.bandeira),
        };

        const options = {
          headers: {
            Authorization: response.data,
          },
        };

        await vindi()
          .post('/public/payment_profiles', request, options)
          .then((response) => {
            paymentTokenVindi = response.data.payment_profile.gateway_token;
          })
          .catch((error) => console.error(error));
      })
      .catch((error) => console.error(error));
    return paymentTokenVindi;
  };

  getPaymentToken = async () => {
    let paymentToken = '';
    let { dadosCartaoDebito, dadosCartao, dadosDePagamentoValido } = this.state;

    const dados =
      dadosDePagamentoValido.tipo === 'cartaoDebito'
        ? dadosCartaoDebito
        : dadosCartao;

    await api()
      .get(
        `/publico/gateway/accesstoken?merchantid=${process.env.REACT_APP_MERCHANT_ID}`,
        {},
      )
      .then(async (response) => {
        const request =
          'HolderName=' +
          this.formatCardHolderName(dados.nome) +
          '&RawNumber=' +
          dados.numero.replace(/[\s _]/g, '') +
          '&Expiration=' +
          dados.validade.replace('/', '%2F20') +
          '&SecurityCode=' +
          dados.CVV +
          '&AccessToken=' +
          response.data;
        await braspag()
          .post('/card', request)
          .then((response) => {
            paymentToken = response.data.PaymentToken;
          })
          .catch((error) => console.error(error));
      })
      .catch((error) => console.error(error));
    return paymentToken;
  };

  iconeBandeira = () => {
    const bandeira = this.state.bandeira;
    switch (bandeira) {
      case 'visa':
        return <CardIcon src={visaLogo} alt="Visa" />;
      case 'master':
        return <CardIcon src={masterLogo} alt="Master" />;
      case 'alelo':
        return <CardIcon src={aleloLogo} alt="Alelo" />;
      case 'elo':
        return <CardIcon src={eloLogo} alt="Elo" />;
      case 'amex':
        return <CardIcon src={amexLogo} alt="Amex" />;
      default:
        return <div style={{ width: '40px' }} />;
    }
  };

  iconeBandeiraAdornment = () => {
    const bandeira = this.state.bandeira;
    if (bandeira === 'visa') return visa;
    if (bandeira === 'master') return master;
    if (bandeira === 'alelo') return alelo;
    if (bandeira === 'elo') return elo;
    if (bandeira === 'amex') return amex;
    return null;
  };

  verificarTrocaCartao(cardNumber) {
    this.verificaCartao(cardNumber);
    const { dadosCartao } = this.state;

    if (!this.validarCvvTrocaCartao(dadosCartao.CVV, cardNumber)) {
      this.setState({ botaoOKcartao: { status: true, label: 'OK' } });
    }
  }

  validarCvvTrocaCartao(cvv, cardNumber) {
    const bandeira = validateCreditCardFlag(cardNumber);
    if (!cvv) return false;
    if (bandeira === 'amex' && cvv.length !== 4) return false;
    if (bandeira !== '' && bandeira !== 'amex' && cvv.length !== 3)
      return false;

    return true;
  }

  verificaCVV = (event) => {
    const cvv = event;
    if (!cvv) return false;
    const bandeira = this.state.bandeira;
    if (bandeira === 'amex' && cvv.length !== 4) return false;
    if (bandeira !== 'amex' && cvv.length !== 3) return false;

    return true;
  };

  verifyAgency = (agency) => {
    return agency.length === 4;
  };

  verifyBankAccountNumber = (number) => {
    return number.length > 0 && number.length <= 7;
  };

  verifyBankDigit = (digit) => {
    return digit.length > 0;
  };

  validateAgencyDV = (formValues) => {
    const AccountNotFoundResponse = {
      valid: false,
      message:
        'Conta informada não confere, por favor verifique e tente novamente!',
    };
    if (
      (formValues.instituicao.substring(0, 3) === BANK_CODE.BB &&
        validateDVAccount(formValues.conta, BANKS.BB) ===
          parseInt(formValues.digitoConta)) ||
      (formValues.instituicao.substring(0, 3) === BANK_CODE.BRADESCO &&
        validateDVAccount(formValues.conta, BANKS.BRADESCO) ===
          parseInt(formValues.digitoConta)) ||
      (formValues.instituicao.substring(0, 3) === BANK_CODE.ITAU &&
        validateItauDVAccount(formValues.agencia + formValues.conta) ===
          parseInt(formValues.digitoConta)) ||
      (formValues.instituicao.substring(0, 3) === BANK_CODE.ORIGINAL &&
        validateDVAccount(formValues.conta, BANKS.ORIGINAL) ===
          parseInt(formValues.digitoConta))
    ) {
      return { valid: true, message: '' };
    } else {
      return AccountNotFoundResponse;
    }
  };

  verifyNameCard = (name) => {
    if (name.length >= 3) return ValidateName.isValid(name);
  };

  verificaCartao = (event) => {
    const numero = event.replaceAll('_', '');
    if (!numero) return false;
    const creditCardFlag = validateCreditCardFlag(numero);
    this.setState({ bandeira: creditCardFlag });
    return validateCreditCard(numero);
  };

  verificaValidade = (valueInput) => {
    const dadosData = valueInput.replace(/_|__/g, '').split('/');

    const mes = dadosData[0];
    const ano = dadosData[1];

    if (mes > 12) return false;
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear().toString().substr(-2);

    if (ano < currentYear) return false;

    if (
      (mes >= currentMonth && ano >= currentYear) ||
      (mes < currentMonth && ano > currentYear)
    ) {
      return true;
    }
    return false;
  };

  formatCardHolderName = (name) => {
    return name
      .toUpperCase()
      .replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'A')
      .replace(new RegExp('[ÉÈÊ]', 'gi'), 'E')
      .replace(new RegExp('[ÍÌÎ]', 'gi'), 'I')
      .replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'O')
      .replace(new RegExp('[ÚÙÛ]', 'gi'), 'U')
      .replace(new RegExp('[Ç]', 'gi'), 'C');
  };

  eventFilterCard = (fieldName) => {
    if (!fieldName.includes('cartao-numero')) {
      this.verifyMaskCard();
    } else {
      this.setState({ showMask: false });
    }
    eventTrackBasic('interacao:campo', `preencheu:${fieldName}`);
  };

  showTip = () => {
    this.setState({ showDebitTip: true });
  };
  closeTip = () => {
    this.setState({ showDebitTip: false });
  };

  verifyMaskCard = () => {
    if (
      this.state.dadosCartao.numero &&
      this.state.dadosCartao.numero.replaceAll(' ', '').replaceAll('_', '')
        .length > 14
    ) {
      this.setState({ showMask: true });
    } else {
      this.setState({ showMask: false });
    }
  };

  render() {
    const { tipoPagamento, totalProdutos, ondeUsar, valorRecarga } =
      this.props.pedido;
    const {
      checkboxTermos,
      botaoContinuar,
      dadosCartaoDebito,
      dadosCartao,
      dadosDePagamentoValido,
      botaoOKcartao,
      botaoOKdebito,
      openModalAguarde,
      openModalInformativo,
      openModalTermos,
      urlContratoVeloeCliente,
      urlManualUsuario,
      urlPoliticaDePrivacidade,
      openModalAtencao,
      showDebitTip,
      debitoEmConta,
      disableAgencia,
      bankOptions,
      validaAgenciaAlert,
      bandeira,
      showMask,
    } = this.state;
    let bancos = [];
    for (let i = 0; bankOptions.length > i; i++) {
      bancos.push(bankOptions[i].label);
    }

    return (
      <div className="containerComponent">
        <div className="containerText">
          <div className="containerLabel">
            {tipoPagamento === 'pos-pago' ? (
              <label className="areaTexto">
                Selecione a forma de pagamento
              </label>
            ) : (
              <label className="areaTexto">Informe os dados de pagamento</label>
            )}
            <div className="containerLblInformativo">
              <div className="containerLblInformativoFormaPagamento">
                <>
                  {!dadosDePagamentoValido.tipo ? (
                    <></>
                  ) : dadosDePagamentoValido.tipo === 'credito' ||
                    dadosDePagamentoValido.tipo === 'cartaoDebito' ? (
                    <>
                      <Icon src={alert} size="md" />
                      <label className="lblInformativoFormaPagamento">
                        Faremos uma cobrança de alguns centavos para validar seu
                        cartão de crédito.
                        {ondeUsar.subProdutoId !== '001' &&
                          `Você só vai pagar a mensalidade
                            após o ${ondeUsar.mesesBonificacao}º mês.`}
                      </label>
                    </>
                  ) : (
                    <>
                      <Icon src={alert} size="md" />
                      <label className="lblInformativoFormaPagamento">
                        {`Você só vai pagar a mensalidade após o ${ondeUsar.mesesBonificacao}º mês. A
                          verificação dos dados de pagamento podem levar até 1
                          dia útil.`}
                      </label>
                    </>
                  )}
                </>
              </div>

              <Card {...{ size: CARD_SIZE.LARGE }}>
                <div className="containerCardResumoPedido">
                  <label className="lblResumo">RESUMO DO PEDIDO</label>

                  {ondeUsar.subProdutoId !== '001' && (
                    <div className="containerDivResumoPedido">
                      <label className="lblPerguntaResumo">Itens</label>
                      <label className="lblRespostaResumo">
                        R$
                        {totalProdutos.valorTotalProdutos
                          .toFixed(2)
                          .replace('.', ',')}
                      </label>
                    </div>
                  )}

                  <>
                    <div className="containerDivResumoPedido">
                      <label className="lblPerguntaResumo">Recarga</label>
                      <label className="lblRespostaResumo">
                        R${valorRecarga},00
                      </label>
                    </div>
                  </>

                  {ondeUsar.subProdutoId !== '001' && (
                    <>
                      <div className="containerDivResumoPedido">
                        <label className="lblPerguntaResumo">Valor</label>
                        <div className="containerValoresMensalidade">
                          <Chips
                            {...{
                              color: CHIPS_COLOR.SUCCESS,
                              label: ondeUsar.textoDesconto,
                              id: 'chips-desconto',
                            }}
                          />
                        </div>
                      </div>
                      <div className="containerDivResumoPedido">
                        <label className="lblRespostaResumo">
                          {ondeUsar.valor}
                        </label>
                      </div>
                    </>
                  )}
                  <div className="containerDivider" />
                  <div className="containerDivResumoPedido">
                    <label className="lblTotalResumo">Total do pedido</label>
                    <label className="lblTotalResumoResposta">
                      R${' '}
                      {(totalProdutos?.valorTotalProdutos + valorRecarga)
                        .toFixed(2)
                        .replace('.', ',')}
                    </label>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </div>

        <div className="containerArea">
          <div className="containerFormaPagamento">
            {ondeUsar.planId === 'ped-est' &&
              tipoPagamento === 'pos-pago' &&
              !this.onTheBlacklist(ondeUsar.codigoPromocional) && (
                <div className="cardPagamento">
                  <div
                    className={
                      dadosDePagamentoValido.status === false &&
                      dadosDePagamentoValido.tipo !== 'cartaoDebito'
                        ? 'containerTituloCartao clicavel'
                        : 'containerTituloCartao'
                    }
                    onClick={() => {
                      this.state.primeiroClick = true;
                      this.limpaDados('cartaoDebito');
                    }}
                  >
                    <img src={credit} alt="" />

                    <div className="containerTituloCartaoDebito">
                      <div className="tituloCartao">Cartão de débito</div>
                      {dadosDePagamentoValido.status === false &&
                        dadosDePagamentoValido.tipo !== 'cartaoDebito' && (
                          <div className="descricaoCartao">
                            Apenas cartões do Banco Bradesco são aceitos.
                          </div>
                        )}
                    </div>
                  </div>

                  {dadosDePagamentoValido.tipo === 'cartaoDebito' &&
                    dadosDePagamentoValido.status === true && (
                      <div className="containerItensCartaoResumo">
                        <label>
                          {this.iconeBandeira()}
                          {'  '} Final ****{' '}
                          {dadosCartaoDebito.numero.substr(
                            dadosCartaoDebito.numero.length - 4,
                          )}
                        </label>
                        <div className="alterarDados">
                          <Link
                            onBg="light"
                            onClick={() => {
                              this.limpaDados('cartaoDebito');
                              this.setState({
                                disableCardClick: false,
                                dadosDePagamentoValido: {
                                  status: false,
                                  tipo: 'cartaoDebito',
                                },
                              });
                            }}
                          >
                            Alterar dados
                          </Link>
                        </div>
                      </div>
                    )}
                  {dadosDePagamentoValido.tipo === 'cartaoDebito' &&
                    dadosDePagamentoValido.status === false &&
                    this.state.primeiroClick && (
                      <div className="containerItensCartao">
                        <div className="debitText">
                          Para o realizar o pagamento será necessário informar
                          um <b>cartão físico</b>. Apenas cartões de débito
                          Bradesco são aceitos.
                        </div>

                        <div className="numberCardInput">
                          {showMask && (
                            <CreditCard
                              errorMessage="Cartão Inválido."
                              isValid={(event) => this.verificaCartao(event)}
                              label="Número"
                              id="cartao-debito-numero"
                              onChange={(event) =>
                                this.changeFormularioDadosCartao(
                                  event,
                                  'numero',
                                )
                              }
                              onFocus={() =>
                                this.eventFilterCard('cartao-numero-creditcard')
                              }
                              value={dadosCartaoDebito.numero}
                              adornment={this.iconeBandeiraAdornment()}
                            />
                          )}
                          {!showMask && (
                            <CreditCardGeneric
                              errorMessage="Cartão Inválido."
                              isValid={(event) => this.verificaCartao(event)}
                              label="Número"
                              id="cartao-debito-numero"
                              onChange={(event) =>
                                this.changeFormularioDadosCartao(
                                  event,
                                  'numero',
                                )
                              }
                              onFocus={() =>
                                this.eventFilterCard('cartao-numero-generic')
                              }
                              value={dadosCartaoDebito.numero}
                              adornment={this.iconeBandeiraAdornment()}
                            />
                          )}
                        </div>
                        <InputText
                          id="cartao-nome"
                          label="Nome impresso"
                          errorMessage="Digite o nome correto impresso no cartão"
                          onKeyPress={(event) => {
                            if (!/^[a-zA-Z ]*$/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          onChange={(event) =>
                            this.changeFormularioDadosCartao(event, 'nome')
                          }
                          onFocus={() => this.eventFilterCard('cartao-nome')}
                          isValid={(event) => this.verifyNameCard(event)}
                          value={dadosCartaoDebito.nome}
                          onPaste={(e) => {
                            e.preventDefault();
                            return false;
                          }}
                          inputProps={{
                            maxLength: 25,
                            className: 'cardName',
                          }}
                        />
                        <div className="carta2input">
                          <div className="input">
                            <CreditCardExpiration
                              errorMessage="Digite uma data válida"
                              isValid={(event) => this.verificaValidade(event)}
                              label="Validade"
                              id="cartao-validade"
                              onChange={(event) =>
                                this.changeFormularioDadosCartao(
                                  event,
                                  'validade',
                                )
                              }
                              onFocus={() => {
                                this.eventFilterCard('cartao-validade');
                              }}
                              value={dadosCartaoDebito.validade}
                            />
                          </div>
                          <div className="input">
                            <InputText
                              errorMessage="Digite o código"
                              isValid={(event) => this.verificaCVV(event)}
                              label="CVV"
                              id="cartao-cvv"
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              onChange={(event) =>
                                this.changeFormularioDadosCartao(event, 'CVV')
                              }
                              onBlur={(event) =>
                                this.changeFormularioDadosCartao(event, 'CVV')
                              }
                              onFocus={() => this.eventFilterCard('cartao-cvv')}
                              updateOnBlur={true}
                              value={dadosCartaoDebito.CVV}
                              inputProps={{
                                maxLength: 4,
                              }}
                            />
                          </div>
                        </div>
                        <Select
                          label="Melhor dia para cobrança"
                          values={this.diaPagto}
                          id="cartao-melhor-dia"
                          onChange={(event) =>
                            this.changeFormularioDadosCartao(
                              event,
                              'melhorDiaCobranca',
                            )
                          }
                          value={dadosCartaoDebito.melhorDiaCobranca}
                        />
                        <Button
                          {...{
                            onBg: 'light',
                            color: 'primary',
                            id: 'btn-ok-cartao-debito',
                            disabled: botaoOKcartao.status,
                            label: botaoOKcartao.label,
                          }}
                          onClick={() => {
                            this.setState({
                              disableCardClick: true,
                              dadosDePagamentoValido: {
                                status: true,
                                tipo: 'cartaoDebito',
                              },
                            });
                          }}
                        />
                      </div>
                    )}
                </div>
              )}

            <div className="cardPagamento">
              <div
                className={
                  dadosDePagamentoValido.status === false &&
                  dadosDePagamentoValido.tipo !== 'credito'
                    ? 'containerTituloCartao clicavel'
                    : 'containerTituloCartao'
                }
                onClick={() => {
                  this.limpaDados('credito');
                }}
              >
                <img src={credit} alt="" />
                <div className="tituloCartao">Cartão de crédito</div>
              </div>
              {dadosDePagamentoValido.tipo === 'credito' &&
                dadosDePagamentoValido.status === true && (
                  <div className="containerItensCartaoResumo">
                    <label>
                      {this.iconeBandeira()}
                      {'  '} Final ****{' '}
                      {dadosCartao.numero.substr(dadosCartao.numero.length - 4)}
                    </label>
                    <div>
                      <Link
                        onBg="light"
                        onClick={() => {
                          this.limpaDados('credito');
                          this.setState({
                            disableCardClick: false,
                            dadosDePagamentoValido: {
                              status: false,
                              tipo: 'credito',
                            },
                          });
                        }}
                      >
                        Alterar dados
                      </Link>
                    </div>
                  </div>
                )}

              {dadosDePagamentoValido.tipo === 'credito' &&
                dadosDePagamentoValido.status === false && (
                  <div className="containerItensCartao">
                    <div className="numberCardInput">
                      {bandeira === 'amex' && showMask && (
                        <CreditCardAmex
                          errorMessage="Cartão Inválido."
                          isValid={(event) => this.verificaCartao(event)}
                          label="Número"
                          id="cartao-numero"
                          onChange={(event) =>
                            this.changeFormularioDadosCartao(event, 'numero')
                          }
                          onFocus={() =>
                            this.eventFilterCard('cartao-numero-amex')
                          }
                          value={dadosCartao.numero}
                          adornment={this.iconeBandeiraAdornment()}
                        />
                      )}
                      {bandeira !== 'amex' && showMask && (
                        <CreditCard
                          errorMessage="Cartão Inválido."
                          isValid={(event) => this.verificaCartao(event)}
                          label="Número"
                          id="cartao-numero"
                          onChange={(event) =>
                            this.changeFormularioDadosCartao(event, 'numero')
                          }
                          onFocus={() =>
                            this.eventFilterCard('cartao-numero-creditcard')
                          }
                          value={dadosCartao.numero}
                          adornment={this.iconeBandeiraAdornment()}
                        />
                      )}
                      {!showMask && (
                        <CreditCardGeneric
                          errorMessage="Cartão Inválido."
                          isValid={(event) => this.verificaCartao(event)}
                          label="Número"
                          id="cartao-numero"
                          onChange={(event) =>
                            this.changeFormularioDadosCartao(event, 'numero')
                          }
                          onFocus={() =>
                            this.eventFilterCard('cartao-numero-generic')
                          }
                          value={dadosCartao.numero}
                          adornment={this.iconeBandeiraAdornment()}
                        />
                      )}
                    </div>
                    <InputText
                      id="cartao-nome"
                      label="Nome impresso"
                      errorMessage="Digite o nome correto impresso no cartão"
                      onKeyPress={(event) => {
                        if (!/^[a-zA-Z ]*$/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onChange={(event) =>
                        this.changeFormularioDadosCartao(event, 'nome')
                      }
                      onFocus={() => this.eventFilterCard('cartao-nome')}
                      isValid={(event) => this.verifyNameCard(event)}
                      value={dadosCartao.nome}
                      onPaste={(e) => {
                        e.preventDefault();
                        return false;
                      }}
                      inputProps={{
                        maxLength: 25,
                        className: 'cardName',
                      }}
                    />
                    <div className="carta2input">
                      <div className="input">
                        <CreditCardExpiration
                          errorMessage="Digite uma data válida"
                          isValid={(event) => this.verificaValidade(event)}
                          label="Validade"
                          id="cartao-validade"
                          onChange={(event) =>
                            this.changeFormularioDadosCartao(event, 'validade')
                          }
                          onFocus={() => {
                            this.eventFilterCard('cartao-validade');
                          }}
                          value={dadosCartao.validade}
                        />
                      </div>
                      <div className="input">
                        <InputText
                          errorMessage="Digite o código"
                          isValid={(event) => this.verificaCVV(event)}
                          label="CVV"
                          id="cartao-cvv"
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          onChange={(event) =>
                            this.changeFormularioDadosCartao(event, 'CVV')
                          }
                          onBlur={(event) =>
                            this.changeFormularioDadosCartao(event, 'CVV')
                          }
                          onFocus={() => this.eventFilterCard('cartao-cvv')}
                          updateOnBlur={true}
                          value={dadosCartao.CVV}
                          inputProps={{
                            maxLength: 4,
                          }}
                        />
                      </div>
                    </div>
                    {ondeUsar.subProdutoId !== '001' && (
                      <Select
                        label="Melhor dia para cobrança"
                        values={this.diaPagto}
                        id="cartao-melhor-dia"
                        onChange={(event) => {
                          this.changeFormularioDadosCartao(
                            event,
                            'melhorDiaCobranca',
                          );
                        }}
                        value={dadosCartao.melhorDiaCobranca}
                      />
                    )}
                    <Button
                      {...{
                        onBg: 'light',
                        color: 'primary',
                        id: 'btn-ok-cartao-credito',
                        disabled: botaoOKcartao.status,
                        label: botaoOKcartao.label,
                      }}
                      onClick={() => {
                        this.setState({
                          disableCardClick: true,
                          dadosDePagamentoValido: {
                            status: true,
                            tipo: 'credito',
                          },
                        });
                      }}
                    />
                  </div>
                )}
            </div>

            {ondeUsar.planId === 'ped-est' &&
              tipoPagamento === 'pos-pago' &&
              !this.onTheBlacklist(ondeUsar.codigoPromocional) && (
                <div className="cardPagamento">
                  <div
                    className={
                      dadosDePagamentoValido.status === false &&
                      dadosDePagamentoValido.tipo !== 'debito'
                        ? 'containerTituloCartao clicavel'
                        : 'containerTituloCartao'
                    }
                    onClick={() => {
                      this.limpaDados('debito');
                    }}
                  >
                    <img src={debit} alt="" />
                    <div className="tituloCartao">Débito em conta</div>
                  </div>
                  {dadosDePagamentoValido.tipo === 'debito' &&
                    dadosDePagamentoValido.status === true && (
                      <div className="containerItensCartaoResumo">
                        <label>{debitoEmConta.instituicao}</label>
                        <label>
                          Ag {debitoEmConta.agencia} - Conta{' '}
                          {debitoEmConta.conta}-{debitoEmConta.digitoConta}
                        </label>
                        <div className="alterarDados">
                          <Link
                            onBg="light"
                            onClick={() => {
                              this.limpaDados('debito');
                              this.setState({
                                disableCardClick: false,
                                dadosDePagamentoValido: {
                                  status: false,
                                  tipo: 'debito',
                                },
                              });
                            }}
                          >
                            Alterar dados
                          </Link>
                        </div>
                      </div>
                    )}
                  {dadosDePagamentoValido.tipo === 'debito' &&
                    dadosDePagamentoValido.status === false && (
                      <div className="containerItensCartao">
                        <div className="debitText">
                          Para o débito automático é necessário liberar a
                          autorização
                          <b> Alelo </b> junto ao seu banco.
                        </div>
                        <div className="debitSubText">
                          Os dados bancários devem ser de{' '}
                          <b> mesma titularidade </b> e não pode ser uma conta
                          poupança :)
                        </div>
                        <Select
                          label="Instituição"
                          values={bancos}
                          id="cartao-instituicao"
                          onChange={(event) =>
                            this.changeDbtContaFormulario(event, 'instituicao')
                          }
                          value={debitoEmConta.instituicao}
                        />
                        <div className="carta2input">
                          <div className="inputDebitAgencyContainer">
                            {disableAgencia && (
                              <InputText
                                label={debitoEmConta.agencia}
                                disabled={this.state.disableAgencia}
                              />
                            )}
                            {!disableAgencia && (
                              <InputText
                                errorMessage="Digite o numero da agência"
                                isValid={(event) => this.verifyAgency(event)}
                                label="Agência"
                                id="cartao-agencia"
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                onChange={(event) =>
                                  this.changeDbtContaFormulario(
                                    event,
                                    'agencia',
                                  )
                                }
                                onClick={(event) => this.showTip(event)}
                                onBlur={(event) =>
                                  this.changeDbtContaFormulario(
                                    event,
                                    'agencia',
                                  )
                                }
                                updateOnBlur={true}
                                value={debitoEmConta.agencia}
                                inputProps={{ maxLength: 4 }}
                                tooltip={true}
                              />
                            )}
                          </div>

                          <div className="inputDebit">
                            <div className="inputDebitAccountContainer">
                              <InputText
                                errorMessage="Digite o número da conta"
                                isValid={(event) =>
                                  this.verifyBankAccountNumber(event)
                                }
                                label="Conta"
                                id="cartao-conta"
                                updateOnBlur={true}
                                inputProps={{
                                  maxLength: 7,
                                }}
                                value={debitoEmConta.conta}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                onClick={(event) => this.closeTip(event)}
                                onChange={(event) =>
                                  this.changeDbtContaFormulario(event, 'conta')
                                }
                                onBlur={(event) =>
                                  this.changeDbtContaFormulario(event, 'conta')
                                }
                              />
                            </div>
                            <div className="inputDebitDigitAccountContainer">
                              <InputText
                                errorMessage="Digite o Dígito"
                                isValid={(event) => this.verifyBankDigit(event)}
                                label="Dígito"
                                id="cartao-digito"
                                onClick={(event) => this.closeTip(event)}
                                onChange={(event) =>
                                  this.changeDbtContaFormulario(
                                    event,
                                    'digitoConta',
                                  )
                                }
                                onBlur={(event) =>
                                  this.changeDbtContaFormulario(
                                    event,
                                    'digitoConta',
                                  )
                                }
                                updateOnBlur={true}
                                value={debitoEmConta.digitoConta}
                                inputProps={{ maxLength: 1 }}
                              />
                            </div>
                          </div>
                        </div>

                        {showDebitTip && (
                          <div className="containerAgenciaTip">
                            <Icon src={alert} size="md" />
                            <label>
                              Não é preciso informar o dígito no campo agência.
                            </label>
                          </div>
                        )}
                        {validaAgenciaAlert && (
                          <div className="containerAgenciaAlert">
                            <Icon src={atencao} size="md" />
                            <label>
                              Verifique seus dados bancários e tente novamente
                            </label>
                          </div>
                        )}
                        <Select
                          label="Melhor dia para cobrança"
                          values={this.diaPagto}
                          id="cartao-melhor-dia"
                          onChange={(event) =>
                            this.changeDbtContaFormulario(
                              event,
                              'melhorDiaCobranca',
                            )
                          }
                          value={debitoEmConta.melhorDiaCobranca}
                        />

                        <Button
                          {...{
                            onBg: 'light',
                            color: 'primary',
                            id: 'btn-ok-cartao-credito',
                            disabled: botaoOKdebito.status,
                            label: botaoOKdebito.label,
                          }}
                          onClick={() => {
                            this.setState({
                              disableCardClick: true,
                              dadosDePagamentoValido: {
                                status: true,
                                tipo: 'debito',
                              },
                              openModalAtencao: true,
                            });
                          }}
                        />
                      </div>
                    )}
                </div>
              )}
            <div className="spacer" />
            <div className="spacer" />
            <div className="containerMarca">
              <label className="lblUmaMarca">Uma marca</label>
              <img src={require(`../../assets/icons/alelo.png`)} alt="Alelo" />
              <label className="lblUmaMarca">empresa do</label>
              <img
                src={require(`../../assets/icons/bancoBradesco.png`)}
                alt="Bradesco"
              />
              <img
                src={require(`../../assets/icons/bancoBrasil.png`)}
                alt="Banco do Brasil"
              />
            </div>
            {dadosDePagamentoValido.status ? (
              <>
                <div className="containerCondicoes">
                  <Checkbox
                    {...{ checked: checkboxTermos }}
                    onClick={this.alteraCheckBox}
                    onBg="light"
                    id="checkbox-termos"
                  />
                  <span>
                    Declaro que li e aceito o{' '}
                    <Link href={urlContratoVeloeCliente} target="_blank">
                      Contrato Veloe,{' '}
                    </Link>
                    <Link href={urlPoliticaDePrivacidade} target="_blank">
                      Política de Privacidade{' '}
                    </Link>
                    e{' '}
                    <Link href={urlManualUsuario} target="_blank">
                      Manual de Usuário.
                    </Link>
                  </span>
                  {openModalTermos &&
                    modalInformativo(
                      true,
                      () => {
                        this.setState({ openModalTermos: false });
                      },
                      'Termos e condições',
                      this.textoTermos,
                    )}
                </div>
                <div className="stack-button-container" />
                <Button
                  className="stack-button-full"
                  {...{
                    onBg: 'light',
                    color: 'primary',
                    id: 'btn-continuar',
                    disabled: botaoContinuar.status,
                    label: botaoContinuar.label,
                  }}
                  onClick={
                    dadosDePagamentoValido.tipo === 'credito' ||
                    dadosDePagamentoValido.tipo === 'cartaoDebito'
                      ? this.geraPagamentoId
                      : this.chamaFuncRand
                  }
                />
              </>
            ) : null}
          </div>
        </div>
        {openModalAguarde &&
          modalFinalizandoPagamento(true, () => {
            this.setState({ openModalAguarde: false });
          })}
        {openModalInformativo &&
          modalInformativo(
            true,
            () => {
              this.setState({ openModalInformativo: false });
            },
            this.state.errorTitleMessage,
            this.state.errorMessage,
          )}
        {openModalAtencao &&
          modalInformativo(
            true,
            () => {
              this.setState({ openModalAtencao: false });
            },
            'Lembre-se de autorizar o débito em conta no seu banco',
            'Assim, você evita problemas no pagamento e o bloqueio do adesivo.',
          )}
        <ScriptTag
          type="text/javascript"
          src={`https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_KEY_RECAPTCHA}`}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ pedido }) => {
  return { pedido };
};
const mapDispatchToProps = (dispatch) => {
  return {
    activeLoader: () => dispatch({ type: 'loader_active' }),
    inactiveLoader: () => dispatch({ type: 'loader_inactive' }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(FormaPagamento));

FormaPagamento.propTypes = {
  pedido: PropTypes.shape({
    tipoPagamento: PropTypes.string,
    totalProdutos: PropTypes.object,
    cupomDesconto: PropTypes.object,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};
